import React, { useEffect, useState } from "react";
import Images from "../Images";
import tw from "tailwind-styled-components";
import Config from "../Config";
import axios from "axios";
import moment from "moment";
import { useDispatch } from "react-redux";
import { Save_User } from "../Redux/actions";
import { Link, useNavigate } from "react-router-dom";
import { Field, Formik, Form } from "formik";
import Select from "react-select";
import { toast } from "react-toastify";
import Checkbox from "react-custom-checkbox";
import { BsCheckLg } from "react-icons/bs";
import { useMutation, useQuery } from "react-query";
import PasswordChecklist from "react-password-checklist"

import {
  Page,
  BoxContainer,
  BoxTitle,
  Underline,
} from "../Components/Styles/PageStyles";
import {
  SubmitBtn,
  PreviewBtn,
  OtherBtn,
  InputGroup,
  FieldWrapper,
  Label,
  CombineInputGroup,
} from "../Components/Styles/InputStyles";
import { useTranslation } from "react-i18next";

const SignupPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState("")
  const [validPassword, IsValidPassword] = useState(false)
  const [showOTP, setShowOTP] = useState(false);
// console.log(showOTP);

  // useEffect(() => {
  //   navigate("/register");
  // }, []);

  const InitialValue = {
    fName: "",
    lName: "",
    clubName: "",
    email: "",
    mobile: "",
    password: "",
  };


  //------- Send Register Request -------
  const RegisterPostFunction = async (values) => {
    // console.log(values);
    const body = new FormData();
    setEmail (values.email);
    body.append("fName", values.fName);
    body.append("lName", values.lName);
    body.append("email", values.email);
    body.append("mobile", values.mobile);
    body.append("clubName", values.clubName);
    body.append("password", password);
    body.append("userType", 5);
    return await axios.post(`${Config.apiUrl}/register`, body, {
      headers: {
        authorization: Config.AxiosConfig.headers.authorization,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
};

  const onSuccess = (res) => {
    
    //refetch();
    if (res?.data?.status == 'OK')
    {
      toast.success(res?.data?.msg || "Success");
      setShowOTP(true);
    }
    else
      toast.error(res?.data?.msg || "Error");
  };

  const onError = (res) => {
    //setOpenUploadModel(false);
    toast.error(res?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: isLoadingReg, mutate: postRegister } =
    useMutation(RegisterPostFunction, {
      onSuccess: onSuccess,
      onError: onError,
    });
  //------- Send Register Request -------


  //------- Send OTP Request -------
  const OTPPostFunction = async (values) => {
      const body = new FormData();
      body.append("email", email);
      body.append("otp", values.otp);
      return await axios.post(`${Config.apiUrl}/otp`, body, {
        headers: {
          authorization: Config.AxiosConfig.headers.authorization,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      });
  };
  
  const onOTPSuccess = (res) => {
      // console.log(res.data);
      if (res?.data?.status == 'OK')
      {
        dispatch(Save_User(res.data.data));
        navigate("/dashboard");
      }
      else
        toast.error(res?.data?.msg || "Error");
    };
  
    const onOTPError = (res) => {
      //setOpenUploadModel(false);
      toast.error(res?.response?.data?.msg || "An Error Occured");
    };
  
    const { isLoading: isLoadingOTP, mutate: postOTP } =
      useMutation(OTPPostFunction, {
        onSuccess: onOTPSuccess,
        onError: onOTPError,
      });
    //------- Send OTP Request -------


  const SubmitHandler = (values) => {
   
    if (!showOTP) {
      //console.log(values);
      //console.log(password);
      //console.log(validPassword);
     // exit();
      //setShowOTP(true);
      if (!values.fName) {
        return toast.error("Please enter first name");
      } else if (!values.lName) {
        return toast.error("Please enter last name");
      } else if (!values.clubName) {
        return toast.error("Please enter association name");
      } else if (!values.email) {
        return toast.error("Please enter email");
      } else if (!values.mobile) {
        return toast.error("Please enter mobile number");
      } else if (password == '' || validPassword == false) {
        return toast.error("Please enter valid password");
      }
     
      postRegister ({...values})
    }
    //otp flow
    else {
      postOTP({...values})
    }


    //runCampaignMutate({ ...values, isScheduled: isSendLater });
  };

  const handleLogin = () => {};

  return (
    <Login>
      {/* <ImageWrapper>
        <SignUpImage src={Images.SignUpImage} alt="Signup Image" />
      </ImageWrapper> */}
      <TextWrapperComp
        password={password}
        IsValidPassword={IsValidPassword}
        setPassword ={setPassword}
        handleLogin={handleLogin}
        showOTP={showOTP}
        setShowOTP={setShowOTP}
        InitialValue={InitialValue}
        SubmitHandler={SubmitHandler}
        t={t}
      />
    </Login>
  );
};

const TextWrapperComp = ({
  password,
  setPassword,
  IsValidPassword,
  handleLogin,
  InitialValue,
  SubmitHandler,
  showOTP,
  setShowOTP, t
}) => (
  <TextWrapper>
    <Container>
      {/* <TextOverlay>
        <img
          src={Images.NurseTextOverlay}
          alt="text-overlay"
          className="w-full h-full object-contain"
        />
      </TextOverlay> */}
      <Center>
        <div className="flex space-x-6">
          <Logo src={Images.GovtLogo} alt="logo" />
          <VerticalBorder />
          <Logo src={Images.Logo} alt="logo" />
        </div>
        <Title>{t("LoginWelcome")}</Title>
        {!showOTP && (
        <SubTitle>{t("Register")}</SubTitle>
        )}
        {showOTP && (
          <>
          <OtpSubTitle>{t("sent_otp")}</OtpSubTitle>
          <DefaultOtpTitle>Or Enter default OTP 1111</DefaultOtpTitle>
          </>
        )}
        <Formik
          initialValues={InitialValue}
          onSubmit={SubmitHandler}

          // enableReinitialize={isInitialValueSaved}
        >
          {(formikProps) => (
            <>
              <Form>
                <FormContainer>
                  {!showOTP && (
                    <>
                      <div className="flex flex-col lg:flex-row items-center space-y-5 lg:space-y-0 lg:space-x-5">
                        <InputGroup>
                          <Label htmlFor="fName">{t("fname")}</Label>
                          <FieldWrapper>
                            <Field name="fName" id="fName" autoComplete="off" />
                          </FieldWrapper>
                        </InputGroup>
                        <InputGroup>
                          <Label htmlFor="lName">{t("lname")}</Label>
                          <FieldWrapper>
                            <Field name="lName" id="lName" autoComplete="off" />
                          </FieldWrapper>
                        </InputGroup>
                      </div>
                      <InputGroup>
                        <Label htmlFor="clubName">
                        {t("name_club")}
                        </Label>
                        <FieldWrapper>
                          <Field
                            name="clubName"
                            id="clubName"
                            autoComplete="off"
                          />
                        </FieldWrapper>
                      </InputGroup>
                      <InputGroup>
                        <Label htmlFor="name">{t("e_address")}</Label>
                        <FieldWrapper>
                          <Field
                            name="email"
                            type="email"
                            id="email"
                            autoComplete="off"
                          />
                        </FieldWrapper>
                      </InputGroup>
                      <InputGroup>
                        <Label htmlFor="mobile">{t("m_number")}</Label>
                        <FieldWrapper>
                          <Field
                            name="mobile"
                            type="number"
                            id="mobile"
                            autoComplete="new-password"
                          />
                        </FieldWrapper>
                      </InputGroup>

                      <InputGroup>
                        <Label htmlFor="password">{t("password")}</Label>
                        <FieldWrapper>
                          <Field
                          onChange={e => setPassword(e.target.value)}
                          value={password}
                            type="password"
                            name="password"
                            id="password"
                            autoComplete="new-password"
                          />
                        </FieldWrapper>
                      </InputGroup>


                      <PasswordChecklist
				// rules={["minLength","specialChar","number","capital"]}
        rules={["minLength","number","capital"]}

				minLength={5}
				value={password}
        // valueAgain={password}
				onChange={(isValid) => {IsValidPassword(isValid)}}
			/>


                    </>


                  )}

                  {showOTP && (
                    <InputGroup className="w-full">
                      <Label htmlFor="otp">{t("e_opt")}</Label>
                      <FieldWrapper>
                        <Field
                          type="number"
                          name="otp"
                          id="otp"
                          autoComplete="off"
                        />
                      </FieldWrapper>
                    </InputGroup>
                  )}
                </FormContainer>

                <div className="mt-8">
                  <SubmitBtn type="submit">
                    {showOTP ? "Register" : t("Get_OTP")}
                  </SubmitBtn>
                  {/* <SubmitBtn type="submit" disabled={runCampaignLoading}>
                    {runCampaignLoading && (
                      <Loading
                        color="white"
                        width={20}
                        height={20}
                        noPadding={true}
                      />
                    )}
                    {!runCampaignLoading && "Send"}
                  </SubmitBtn> */}
                </div>
              </Form>
            </>
          )}
        </Formik>

        <Link className="my-5 " to="/">
          <p className="text-sm text-gray-500 pb-5 ">
            {t("have_account")}{" "}
            <span className="text-cyan-600 font-medium">{t("login")}</span>
          </p>
        </Link>
      </Center>

      {/* <SmallText>
        Virtual health professionals to help with all your rapid testing needs.
      </SmallText> */}
    </Container>
  </TextWrapper>
);

const FormContainer = tw.div` grid max-w-sm  mt-5 w-full gap-5 md:gap-5`;
const Login = tw.section`h-screen  flex  bg-white justify-center items-center`;
const Container = tw.div`flex flex-col h-full w-full justify-center  items-start   `;
const Logo = tw.img`w-16  mb-6`;
const TextWrapper = tw.div`h-full relative`;
const TextOverlay = tw.section`absolute -right-40 top-0 h-full  `;

//const Title = tw.h1`text-xl sm:text-2xl font-light text-gray-800 tracking-wider`;
const VerticalBorder = tw.div`w-0.5 h-14 bg-gray-300 mt-4`;

//const SubTitle = tw.h3`mt-1 sm:mt-2 tracking-wider  text-gray-500 text-sm  `;
const Title = tw.h1`text-xl sm:text-2xl font-light text-gray-800 tracking-wider`;

const SubTitle = tw.h3`mt-1 sm:mt-2 tracking-wider  text-gray-500 text-sm `;
const OtpSubTitle = tw.h3`mt-2 sm:mt-2 tracking-wider  text-gray-900 text-sm `;
const DefaultOtpTitle = tw.h3`mt-1 sm:mt-1 tracking-wider  text-gray-700 text-sm `;


const Button = tw.button` mt-10 h-20 w-96  md:w-72 lg:w-96 px-5   text-gray-800 flex items-center border rounded-md bg-white z-10 loginBtn  `;

const ImageWrapper = tw.div`hidden h-full  md:block md:w-1/2  `;
const SignUpImage = tw.img`h-full w-full object-cover`;

const Center = tw.div`h-full w-11/12  py-10 mb-5  flex flex-col   `;
const SmallText = tw.p`text-xs font-normal text-gray-400 `;

export default SignupPage;
